var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReadTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79499 1.15344C7.06834 0.889574 7.06834 0.461766 6.79499 0.197903C6.52164 -0.0659675 6.0784 -0.0659675 5.80504 0.197903L2.52946 3.35964L1.20423 2.03134C0.936071 1.76256 0.492927 1.75445 0.214453 2.0133C-0.0640219 2.27215 -0.0723869 2.69985 0.195777 2.9687L2.01578 4.79301C2.14614 4.92369 2.32548 4.99828 2.51343 4.99997C2.70131 5.00166 2.88212 4.93038 3.01498 4.80207L6.79499 1.15344Z",
    fill: "#4A9A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadTick);
export default __webpack_public_path__ + "static/media/read-tick.9ee9655053e5c4fb97858ccb4fcb9d16.svg";
export { ForwardRef as ReactComponent };